import { create } from 'zustand'

export type ToastType = 'success' | 'error' | 'warning' | 'info' | 'loading'

export interface Toast {
  id: string
  type: ToastType
  message: string
  title?: string
  /** ms do automatického zmizení; 0 = drží (typicky 'loading', dokud se neaktualizuje/zavře) */
  duration: number
}

interface ToastState {
  toasts: Toast[]
  add: (t: Omit<Toast, 'id' | 'duration'> & { id?: string; duration?: number }) => string
  update: (id: string, patch: Partial<Omit<Toast, 'id'>>) => void
  dismiss: (id: string) => void
  clear: () => void
}

const MAX_STACK = 5
let seq = 0

export const useToastStore = create<ToastState>((set) => ({
  toasts: [],
  add: ({ id, type, message, title, duration }) => {
    let tid = id ?? `toast-${++seq}`
    set((s) => {
      // Dedupe: stejná hláška (type+message) se neukáže vícekrát naráz — typicky když
      // selže víc volání stejným způsobem nebo retry. Jen obnovíme tu existující.
      if (!id) {
        const dup = s.toasts.find((x) => x.type === type && x.message === message)
        if (dup) {
          tid = dup.id
          return { toasts: s.toasts.map((x) => (x.id === dup.id ? { ...x, duration: duration ?? 4000 } : x)) }
        }
      }
      const toast: Toast = { id: tid, type, message, title, duration: duration ?? 4000 }
      const exists = s.toasts.some((x) => x.id === tid)
      const next = exists ? s.toasts.map((x) => (x.id === tid ? toast : x)) : [...s.toasts, toast]
      return { toasts: next.slice(-MAX_STACK) } // stackuje, ale max N najednou
    })
    return tid
  },
  update: (id, patch) => set((s) => ({ toasts: s.toasts.map((x) => (x.id === id ? { ...x, ...patch } : x)) })),
  dismiss: (id) => set((s) => ({ toasts: s.toasts.filter((x) => x.id !== id) })),
  clear: () => set({ toasts: [] }),
}))
